import {resolveQuery} from '../url/index'

export const UA = window.navigator.userAgent
// eslint-disable-next-line no-useless-escape
const alipayInfo = UA.match(/AlipayClient\/([\d\.]+)/i)
export const isAlipay = !!alipayInfo

export const alipayVersion = alipayInfo && alipayInfo[1]

// eslint-disable-next-line no-useless-escape
const wechatInfo = UA.match(/MicroMessenger\/([\d\.]+)/i)

export const isWechat = !!wechatInfo

export const wechatVersion = wechatInfo && wechatInfo[1]

// eslint-disable-next-line no-useless-escape
export const isMqq = /QQ\/([\d\.]+)/i.test(UA)

// eslint-disable-next-line no-useless-escape
const mqqInfo = UA.match(/QQ\/([\d\.]+)/i)
export const mqqVersion = mqqInfo && mqqInfo[1]

export const isDidiSDK = /didi\.sdk/i.test(UA)

export const isAndroid = /Android/i.test(UA)

export const isIOS = /iphone|ipad|ipod|ios/i.test(UA)

const isPassenger = /didi.passenger.*?\/([\d.]+)/i.test(UA)

const passengerInfo = UA.match(/didi.passenger.*?\/([\d.]+)/i)

export const passengerVersion = passengerInfo && passengerInfo[1]

const isDriver = /didigsui.*_(.+)_\d+.*/i.test(UA) || /ddudriver.*_(\d+\.\d+\.\d+).*/i.test(UA)

const isHonghu = /mvpdriver/.test(UA)

const driverInfo = UA.match(/didigsui.*_(.+)_\d+.*/i) || UA.match(/ddudriver.*_(\d+\.\d+\.\d+).*/i)

export const driverVersion = driverInfo && driverInfo[1]
const webappReg = /webapp$/i
const iosReg = /iphone|ipad|ipod/i
const query = resolveQuery((window.location && window.location.href) || '')

export default {
  lang: query.lang || 'zh-CN',
  isZHCN: query.lang === 'zh-CN',
  isENUS: query.lang === 'en-US',
  isZHHK: query.lang === 'zh-HK',
  isZHTW: query.lang === 'zh-TW',
  isTW: /^886500.*$/.test(query.fcityid) || ((!query.fcityid) && query.lang === 'zh-TW'),
  isHK: /357/.test(query.fcityid) || ((!query.fcityid) && query.lang === 'zh-HK'),
  isWebapp: !!webappReg.exec(query.from || ''),
  isIos: !!iosReg.exec(navigator.userAgent),
  UA,
  isAlipay,
  alipayVersion,
  isWechat,
  wechatVersion,
  isMqq,
  mqqVersion,
  isDidiSDK,
  isPassenger,
  passengerVersion,
  isDriver,
  driverVersion,
  isAndroid,
  isIOS,
  isHonghu
}
